import { Table } from 'antd'
import { DatePicker, Input, Button, message } from 'antd';
import { Formik } from "formik";
import { SearchOutlined } from '@ant-design/icons';
import moment from 'moment';
import *  as ReportAPI from '../../services/Report';
import { useEffect, useState } from 'react';
import Constants from '../../constants/Constants';
const { RangePicker } = DatePicker;

////สถิติคำถาม / คำตอบ
const Report4 = () => {
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPage, setTotalPage] = useState<number>(0);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [date_from, setDate_from] = useState<string|null>('');
    const [date_to, setDate_to] = useState<string|null>('');
    const [reportData, setReportData] = useState();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const columns = [
        {
            title: 'ลำดับ',
            dataIndex: 'no',
            key: 'no',
            className: 'text-center',
        },
        {
            title: 'วันที่และเวลา',
            dataIndex: 'created_at',
            key: 'created_at',
            width: '200px',
            className: 'text-center',
        },
        {
            title: 'IP / Agent',
            dataIndex: 'ip_address_agent',
            key: 'ip_address_agent',
            className: 'text-center',
        },
        {
            title: 'ข้อความ False Message',
            key: 'text',
            dataIndex: 'text',
        },
        {
            title: 'ภาษา',
            key: 'locale',
            dataIndex: 'locale',
            className: 'text-center',
        },
        {
            title: 'ช่องทาง / Platform',
            key: 'platform',
            dataIndex: 'platform',
            className: 'text-center',
        },
    ];

    useEffect(() => {
        onSearch({})
    }, [])
    // const initData = async () => {
    //     setIsLoading(true)
    //     await getReportData()
    //     setIsLoading(false)
    // }

    const onExportData = () => {
        window.open(ReportAPI.getExportReportFalseMessage({date_from, date_to, page: currentPage, limit: pageLimit}))
        message.success('Export data to excel successful.')
    }

    // const getReportData = async () => {
    //     try {
    //         let res_report = await ReportAPI.getReportIntent(date_from, date_to, page, pageLimit)
    //         if (res_report.status === 200) {
    //             let reportData = res_report.data.data
    //             reportData.map((item: any) => {
    //                 item.key = item.no
    //             })
    //             console.log('reportData', reportData)
    //             setReportData(reportData)
    //         }
    //     } catch (error: any) {
    //         console.log('error', error)
    //         if (error?.response?.message) {
    //             message.error(error.response.message)
    //         }
    //     }
    // }

    const onChangePage = async (page: any, pageLimit:any) => {
        setPageLimit(pageLimit)
        setIsLoading(true)
        let res_search = await ReportAPI.getReportFalseMessage({date_from, date_to, page, limit: pageLimit})
        if (res_search.status === 200) {
            let reportData = res_search.data.data
            let meta = res_search.data.meta
            reportData.map((item: any, index:any) => {
                item.no = index+1+((page-1)*pageLimit)
                item.key = item.id
                item.ip_address_agent = item.platform=="FACEBOOK" ? item.platform : item.ip_address + " / " + item.device_type
                item.created_at = moment(item.created_at).add(543, "year").format("DD MMM YYYY HH:mm:ss")
            })
            setCurrentPage(meta.currentPage)
            setReportData(reportData)
        }
        setIsLoading(false)
    }

    const onSearch = async (values: any) => {
        setIsLoading(true)
        try {
            let date_from:any = values.date ? moment(values.date[0]).format('YYYY-MM-DD') : null
            let date_to:any = values.date ? moment(values.date[1]).format('YYYY-MM-DD') : null
            let page: number = 1
            let res_search = await ReportAPI.getReportFalseMessage({date_from, date_to, page, limit: pageLimit})
            if (res_search.status === 200) {
                let reportData = res_search.data.data
                let meta = res_search.data.meta
                reportData.map((item: any, index:any) => {
                    item.no = index+1+((page-1)*pageLimit)
                    item.key = item.id
                    item.ip_address_agent = item.platform=="FACEBOOK" ? item.platform : item.ip_address + " / " + item.device_type
                    item.created_at = moment(item.created_at).add(543, "year").format("DD MMM YYYY HH:mm:ss")
                })
                setTotalPage(meta.totalItems)
                setReportData(reportData)
            }
            setDate_from(date_from)
            setDate_to(date_to)
            setCurrentPage(1)
        } catch (error: any) {
            message.error(error)
        }
        setIsLoading(false)
    }

    return (
        <div className='row gy-5 g-xl-8'>
            <div className={`card card-xl-stretch mb-xl-8 bg-white`}>
                <div className='card-body pt-5 p-8'>
                    <div style={{ textAlign: 'center', margin: 20 }}>

                        <Formik
                            initialValues={{ date: "" }}
                            onSubmit={(values, { setSubmitting }) => {
                                onSearch(values)
                                setSubmitting(false);
                            }}
                        >
                            {props => {
                                const {
                                    values,
                                    touched,
                                    errors,
                                    dirty,
                                    isSubmitting,
                                    handleChange,
                                    handleBlur,
                                    handleSubmit,
                                    handleReset,
                                    setFieldValue
                                } = props;
                                return (
                                    <form onSubmit={handleSubmit}>
                                        <Input.Group compact>
                                            <RangePicker
                                                name="date"
                                                value={values.date as any}
                                                onChange={(dateString) => setFieldValue('date', dateString)}
                                            />
                                            <Button type="primary" htmlType="submit" >ค้นหา <SearchOutlined /></Button>
                                        </Input.Group>
                                    </form>
                                );
                            }}
                        </Formik>
                    </div>
                    <div style={{ textAlign: 'right', marginBottom: 10 }}>
                        <Button type='primary' onClick={() => onExportData()}>
                            Export To Excel
                        </Button>
                    </div>
                    <Table
                        columns={columns}
                        dataSource={reportData}
                        loading={isLoading}
                        pagination={{
                            current: currentPage,
                            total: totalPage,
                            pageSize: pageLimit,
                            onChange: (page, pageSize) => {
                                onChangePage(page, pageSize)
                            }
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export { Report4 }